// src/components/BoardOfEd/components/Program3100.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_3100_CONFIG = {
  fullName: "ELEMENTARY OPERATIONS K-6",
  docId: "3100",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsAdmin",
      label: "Positions – Administrative",
      valueType: "count",
      sources: [{ block: "Positions", key: "Administrative" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsSecretarial",
      label: "Positions – Secretarial",
      valueType: "count",
      sources: [{ block: "Positions", key: "Secretarial" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsParaeducators",
      label: "Positions – Paraeducators",
      valueType: "count",
      sources: [{ block: "Positions", key: "Paraeducators" }],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesAdmin",
      label: "Salaries – Administrative",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Administrative" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSecretarial",
      label: "Salaries – Secretarial",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Secretarial" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesClericalPT",
      label: "Salaries – Clerical, P-T",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Clerical, P-T" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesParaeducators",
      label: "Salaries – Paraeducators",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Paraeducators" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesGreeters",
      label: "Salaries – Greeters",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Greeters" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTeamLeadersGW",
      label: "Salaries – Team Leaders Stipends (GW)",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Team Leaders Stipends (GW)" },
        { block: "Salaries", key: "Team Leaders Stipends(GW)" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesParaprofessionalsPT",
      label: "Salaries – Paraprofessionals, P-T",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Paraprofessionals, P-T" }],
      group: "salaries",
      defaultVisible: false,
    },

    // PURCHASED SERVICES
    {
      key: "printing",
      label: "Printing",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Printing" }],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "copiers",
      label: "Copiers",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Copiers" }],
      group: "services",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "publications",
      label: "Publications",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Publications" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "superStarProgramGW",
      label: "Super Star Program (GW)",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Super Star Program (GW)" },
        { block: "Supplies / Materials", key: "Super Star Program (Gw)" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "schoolFunctionCosts",
      label: "School Function Costs",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "School Function Costs" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "welcomeDayCommConnectors",
      label: "Welcome Day / Comm Connectors",
      valueType: "currency",
      sources: [
        {
          block: "Supplies / Materials",
          key: "Welcome Day / Comm Connectors",
        },
        {
          block: "Supplies / Materials",
          key: "Welcome Day/Comm Connectors",
        },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "travelReimbursement",
      label: "Travel Reimbursement",
      valueType: "currency",
      sources: [{ block: "Other", key: "Travel Reimbursement" }],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "duesFees",
      label: "Dues / Fees",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Dues/Fees" },
        { block: "Other", key: "Dues / Fees" },
        { block: "Other", key: "Dues and Fees" },
      ],
      group: "other",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "Approved Budget",
      sectionKey: "Approved",
      fields: [
        // Positions
        "positionsAdmin",
        "positionsSecretarial",
        "positionsParaeducators",

        // Salaries
        "salariesAdmin",
        "salariesSecretarial",
        "salariesClericalPT",
        "salariesParaeducators",
        "salariesGreeters",
        "salariesTeamLeadersGW",
        "salariesParaprofessionalsPT",

        // Purchased Services
        "printing",
        "copiers",

        // Supplies / Materials
        "publications",
        "superStarProgramGW",
        "schoolFunctionCosts",
        "welcomeDayCommConnectors",

        // Other
        "travelReimbursement",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "140px" },
        positionsSecretarial: { minWidth: "130px" },
        positionsParaeducators: { minWidth: "130px" },

        // Salaries
        salariesAdmin: { minWidth: "140px" },
        salariesSecretarial: { minWidth: "130px" },
        salariesClericalPT: { minWidth: "140px" },
        salariesParaeducators: { minWidth: "140px" },
        salariesGreeters: { minWidth: "120px" },
        salariesTeamLeadersGW: { minWidth: "190px" },
        salariesParaprofessionalsPT: { minWidth: "190px" },

        // Purchased Services
        printing: { minWidth: "110px" },
        copiers: { minWidth: "120px" },

        // Supplies / Materials
        publications: { minWidth: "110px" },
        superStarProgramGW: { minWidth: "170px" },
        schoolFunctionCosts: { minWidth: "150px" },
        welcomeDayCommConnectors: { minWidth: "200px" },

        // Other
        travelReimbursement: { minWidth: "150px" },
        duesFees: { minWidth: "110px" },
      },
    },
    {
      id: "actual",
      title: "Actual Spending",
      sectionKey: "Actual",
      fields: [
        // Positions
        "positionsAdmin",
        "positionsSecretarial",
        "positionsParaeducators",

        // Salaries
        "salariesAdmin",
        "salariesSecretarial",
        "salariesClericalPT",
        "salariesParaeducators",
        "salariesGreeters",
        "salariesTeamLeadersGW",
        "salariesParaprofessionalsPT",

        // Purchased Services
        "printing",
        "copiers",

        // Supplies / Materials
        "publications",
        "superStarProgramGW",
        "schoolFunctionCosts",
        "welcomeDayCommConnectors",

        // Other
        "travelReimbursement",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "140px" },
        positionsSecretarial: { minWidth: "130px" },
        positionsParaeducators: { minWidth: "130px" },

        // Salaries
        salariesAdmin: { minWidth: "140px" },
        salariesSecretarial: { minWidth: "130px" },
        salariesClericalPT: { minWidth: "140px" },
        salariesParaeducators: { minWidth: "140px" },
        salariesGreeters: { minWidth: "120px" },
        salariesTeamLeadersGW: { minWidth: "190px" },
        salariesParaprofessionalsPT: { minWidth: "190px" },

        // Purchased Services
        printing: { minWidth: "110px" },
        copiers: { minWidth: "120px" },

        // Supplies / Materials
        publications: { minWidth: "110px" },
        superStarProgramGW: { minWidth: "170px" },
        schoolFunctionCosts: { minWidth: "150px" },
        welcomeDayCommConnectors: { minWidth: "200px" },

        // Other
        travelReimbursement: { minWidth: "150px" },
        duesFees: { minWidth: "110px" },
      },
    },
  ],
};

export function Program3100(props) {
  return (
    <ProgramBudget programId="3100" config={PROGRAM_3100_CONFIG} {...props} />
  );
}
